<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';

import AuditTrailSection from 'next/wgpt/AuditTrail/AuditTrailSection.vue';

const route = useRoute();
const getters = useStoreGetters();
const { t } = useI18n();

const campaign = computed(() =>
  getters['wgptCampaigns/getCampaign'].value(route.params.campaignId)
);

const auditTrailFilters = computed(() => {
  if (!campaign.value?.id) return [];

  const filters = [
    {
      attributeKey: 'model',
      filterOperator: 'equal_to',
      values: {
        id: 'WgptCampaign',
        name: 'WgptCampaign',
      },
      queryOperator: 'and',
      attributeModel: 'standard',
    },
    {
      attributeKey: 'id',
      filterOperator: 'equal_to',
      values: campaign.value.id,
      queryOperator: 'or',
      attributeModel: 'standard',
    },
  ];

  if (campaign.value.automation_id) {
    filters.push(
      {
        attributeKey: 'model',
        filterOperator: 'equal_to',
        values: {
          id: 'WgptAutomation',
          name: 'WgptAutomation',
        },
        queryOperator: 'and',
        attributeModel: 'standard',
      },
      {
        attributeKey: 'id',
        filterOperator: 'equal_to',
        values: campaign.value.automation_id,
        queryOperator: 'or',
        attributeModel: 'standard',
      }
    );
  }

  return filters;
});
</script>

<template>
  <AuditTrailSection
    v-if="campaign?.id"
    :title="t('WGPT_CAMPAIGNS.EDITOR.SIDEBAR.SETTINGS.AUDIT_TRAIL.TITLE')"
    :description="
      t('WGPT_CAMPAIGNS.EDITOR.SIDEBAR.SETTINGS.AUDIT_TRAIL.DESCRIPTION')
    "
    :filters="auditTrailFilters"
  />
</template>
